<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
    <v-card-title class="headline">Reply With</v-card-title>

    <v-card-text>

       <p>Enter the text message you want to send to the customer.</p>
       <p>To use a Saved Message, begin your reply with a # character.</p>
       <p>Use the special message <code>test:sametime</code> to test a situation where another RedChirp user responds to this customer a fraction of a second ahead of you.</p>

    </v-card-text>

    <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
            color="primary darken-1"
            text
            @click="onOk"
        >
        Ok
        </v-btn>
    </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
export default {
    data() {
        return {
            dialog: false
        }
    },

    methods: {
        showDialog() {
            this.dialog = true;
        },

        onOk() {
            this.dialog = false;
        }
    },
}
</script>

<style lang="scss" scoped>

</style>